import { render, staticRenderFns } from "./VerticalBarSkills.vue?vue&type=template&id=b96b7aa0&"
import script from "./VerticalBarSkills.vue?vue&type=script&lang=js&"
export * from "./VerticalBarSkills.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBarSkills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports